// Pathify
import { make } from 'vuex-pathify'

// Data
const state = {
  drawer: null,
  drawerImage: true,
  mini: false,
  items: [
    {
      title: 'Accueil',
      icon: 'mdi-home',
      to: '/',
    },
    {
      title: 'ANR',
      icon: 'mdi-alpha-a',
      to: '/ANR',
    },
    {
      title: 'France 2030',
      icon: 'mdi-alpha-f',
      to: '/France30',
    },
    {
      title: 'Horizon Europe',
      icon: 'mdi-alpha-h',
      to: '/Europe',
    },
    {
      title: 'Start-up Deeptech',
      icon: 'mdi-alpha-s',
      to: '/Deeptech',
    },
    {
      title: 'Valorisation de la recherche',
      icon: 'mdi-alpha-v',
      to: '/ValoRecherche',
    },
    // {
    //   title: 'Admin Page',
    //   icon: 'mdi-view-dashboard',
    //   to: '/AdminPage',
    // },
  ],
}

const mutations = make.mutations(state)

const actions = {
  ...make.actions(state),
  init: async ({ dispatch }) => {
    //
  },
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,

}
